import cohortTabTemplate from './cohortTabTemplate';

export default cohortTabTemplate(['cohorts'], ({ cohorts }) => cohorts.read);
